import { gql } from '@apollo/client';

export const UpdateSettings = gql`
mutation UpdateSettings($updateSettingsId: ID!, $content: contentSettings!) {
  updateSettings(id: $updateSettingsId, content: $content) {
    status
  }
}
`;